export class GwpProgress extends HTMLElement {
  async connectedCallback() {
    await this.removeInvalidGifts(this.dataset.giftsToRemove);
    await this.addGifts(this.dataset.giftsToAdd);
  }

  async removeInvalidGifts(invalidGiftItems) {
    if (!invalidGiftItems) return;

    try {
      const updates = invalidGiftItems.split(',').reduce((acc, key) => {
        acc[key] = 0;
        return acc;
      }, {});
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates,
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to remove invalid gifts');
      }

      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));

      if (window.location.pathname === `${Shopify.routes.root}cart`) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error removing invalid gifts', error);
    }
  }

  async addGifts(giftsToAdd) {
    if (!giftsToAdd) return;

    try {
      const items = giftsToAdd.split(',').map((key) => {
        const [giftId, variantId] = key.split(':');
        return {
          id: variantId,
          quantity: 1,
          properties: {
            _bl_gwp: giftId,
          },
        };
      });
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: items,
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to add gifts');
      }

      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));

      if (window.location.pathname === `${Shopify.routes.root}cart`) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error adding gifts', error);
    }
  }
}

if (!customElements.get('gwp-progress')) {
  customElements.define('gwp-progress', GwpProgress);
}

export class GwpProductCard extends HTMLElement {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get form() {
    return this.querySelector('form');
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.handleSubmit);
    this.submitButton = this.form.querySelector("[type='submit']");
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.handleSubmit);
  }

  async handleSubmit(event) {
    event.preventDefault();

    try {
      if (this.submitButton.disabled) return;

      this.submitButton.disabled = true;
      this.submitButton.textContent = 'Adding...';

      const formData = new FormData(event.target);
      const response = await fetch(event.target.action, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to submit form');
      }

      this.submitButton.textContent = 'Added!';

      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));

      if (window.location.pathname === `${Shopify.routes.root}cart`) {
        window.location.reload();
      }
    } catch (error) {
      console.error('error', error);
      this.submitButton.textContent = 'Error';
    } finally {
      setTimeout(() => {
        this.submitButton.disabled = false;
        this.submitButton.textContent = 'Add to Cart';
      }, 2000);
    }
  }
}

if (!customElements.get('gwp-product-card')) {
  customElements.define('gwp-product-card', GwpProductCard);
}
